export const siteConfig = {
  name: '韩漫阁',
  tagline: '韩国漫画网-无遮韩国免费漫画大全',
  description: '韩漫阁提供免费无遮漫画下拉式阅读服务，整合全网漫画韩漫资源，支持韩漫在线阅读，致力于打造无障碍的漫画阅读环境。海量韩国漫画、热血漫画、恋爱漫画、奇幻漫画等你来发现。',
  url: 'http://godhands.cn/',
  logo: '韩漫阁',
  keywords: '韩国漫画,无遮漫画,免费漫画,韩漫在线阅读,漫画韩漫网址,下拉式漫画',
  email: 'hello@godhands.cn',
  phone: '400-888-6666',
  address: '北京市朝阳区望京SOHO T3 20层',
  social: {
    siteLink: 'http://godhands.cn/',
    wechat: 'hanmange_official',
  },
};

export const seoMeta = {
  home: {
    title: '韩漫阁-韩国漫画网|无遮韩国免费漫画大全|免费在线阅读韩漫',
    description: '韩漫阁-韩国漫画网提供免费无遮漫画下拉式服务，整合漫画韩漫网址，支持韩漫在线阅读。海量热血、恋爱、奇幻、都市韩国漫画免费看，每日更新，打造无障碍漫画阅读环境。',
    keywords: '韩国漫画,无遮漫画,免费漫画,韩漫在线阅读,漫画韩漫网址,下拉式漫画,韩漫网站',
  },
  category: {
    title: '韩漫分类-免费韩国漫画分类浏览|韩漫阁',
    description: '按分类浏览海量韩国漫画：热血漫画、恋爱漫画、奇幻漫画、都市漫画、悬疑漫画、搞笑漫画。免费无遮下拉式阅读体验，每日更新。',
    keywords: '韩国漫画分类,热血漫画,恋爱漫画,奇幻漫画,免费韩漫分类',
  },
  article: {
    title: '韩漫在线阅读',
    description: '韩漫阁提供免费无遮下拉式韩国漫画在线阅读，高清画质，流畅阅读体验。',
    keywords: '韩漫在线阅读,韩国漫画阅读,无遮漫画阅读',
  },
  about: {
    title: '关于韩漫阁-品牌介绍|商务合作|联系我们',
    description: '韩漫阁致力于打造无障碍的韩国漫画阅读平台。了解我们的品牌故事、平台数据、用户口碑以及商务合作联系方式。',
    keywords: '韩漫阁,关于我们,漫画平台,商务合作,联系我们',
  },
};